import * as React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { DomainDetail } from "./detail";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { Loader } from "../../components/layout/loader";
import { DOMAIN_UPDATE_INTERVAL_MS } from "../../envVariables";
import { useGetDomainQuery } from "../../store/api/domainApi";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { selectContext } from "../../store/contextSlice";
import { formActions } from "../../store/formSlice";

type RouteParams = "org" | "domain";
export const DomainDetailRoute: React.FC = () => {
  const dispatch = useAppDispatch();
  const context = useAppSelector(selectContext);
  const navigate = useNavigate();

  const { org: orgName, domain: domainName } = useParams<RouteParams>();
  const location = useLocation();
  const isOnAuditTrail = location.pathname.endsWith("/audit-trail");

  const selfLink = `/org/${orgName}/domain/${domainName}`;
  const { data: domain, isLoading, isError, refetch } = useGetDomainQuery(selfLink || "", {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
    pollingInterval: isOnAuditTrail ? 0 : DOMAIN_UPDATE_INTERVAL_MS,
  });

  if (isLoading) {
    return <Loader fullScreen />;
  }

  if (isError || !domain) {
    return <IncorrectItem kind={"domain"} canCreate={true} />;
  }

  return (
    <DomainDetail
      key={domain.version}
      domain={domain}
      refetch={refetch}
      onEdit={() => {
        dispatch(formActions.setDomain(domain));
        navigate(`/console/org/${context.org}/domain/-draft`);
      }}
    />
  );
};
